import { useMemo } from "react";

import _THEME from "config/app.theme";

const RGBtoHEX = (grad: any[]) =>
  "#" + grad.map((col) => col.toString(16)).join("");

type CRLogoSVGProps = {
  width?: number;
  height?: number;
  variant?: string;
  uid?: string;
  gradToUse?: string;
};

function create_UUID(){
  var dt = new Date().getTime();
  var uuid = 'xxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
      var r = (dt + Math.random()*16)%16 | 0;
      dt = Math.floor(dt/16);
      return (c=='x' ? r :(r&0x3|0x8)).toString(16);
  });
  return uuid;
}

const CRLogoSVG = ({
  width,
  height,
  variant,
  uid,
  gradToUse = "retail",
}: CRLogoSVGProps) => {
  let viewbox: string;
  uid = uid ? `${uid}_` : create_UUID();

  const grad = useMemo(
    () => ({
      start: RGBtoHEX(_THEME.colours.gradientStart[gradToUse]),
      end: RGBtoHEX(_THEME.colours.gradientEnd[gradToUse]),
      accent: RGBtoHEX(_THEME.colours.gradAccent[gradToUse]),
    }),
    [gradToUse]
  );

  switch (variant) {
    case "icon":
      viewbox = "0 0 65.96 65.96";
      break;
    case "logo":
      viewbox = "0 0 280 65.96";
      break;
    case "full":
      viewbox = "0 0 571.96 65.96";
      break;
    default:
      viewbox = "0 0 280 65.96";
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : undefined}
      height={height ? height : undefined}
      viewBox={viewbox}
    >
      <g id={`${uid}Isolation_Mode`}>
        {/* Roundel */}
        <g>
          <linearGradient
            id={`${uid}SVGID_1_`}
            gradientUnits="userSpaceOnUse"
            x1=".82"
            y1="32.98"
            x2="59.437"
            y2="32.98"
          >
            <stop offset="0%" stopColor={grad.start} />
            <stop offset="100%" stopColor={grad.end} />
          </linearGradient>
          <path
            fill={`#F73261`}
            d="
                        M32.98 15.73
                        C42.51 15.73
                        50.23 23.45
                        50.23 32.98
                        L65.96 32.98
                        C65.96 14.77
                        51.19 0
                        32.98 0
                        C14.77 0
                        0     14.77
                        0     32.98
                        C0     51.19
                        14.77 65.96
                        32.98 65.96
                        C51.19 65.96
                        65.96 51.19
                        65.96 32.98
                        L50.23 32.98
                        C50.23 42.53
                        42.53 50.23
                        32.98 50.23
                        C23.45 50.23
                        15.73 42.53
                        15.73 32.98
                        C15.73 23.45
                        23.45 15.73
                        32.98 15.73Z
                    "
          />
          <path
            fill={grad.accent}
            d="
                        M61.34 16.00
                        L47.50 23.87
                        A17.25 17.25
                        0 0 1
                        47.50 42.09
                        L61.34 49.96
                        A32.98 32.98
                        0 0 0
                        61.34 16.00Z
                    "
          />
        </g> 

        {/* Logo text */}
        <g>
          <linearGradient
            id={`${uid}SVGID_2_`}
            gradientUnits="userSpaceOnUse"
            x1="920.138"
            y1="375.208"
            x2="1020.371"
            y2="375.208"
            gradientTransform="translate(-837 -331)"
          >
            <stop offset="0" stopColor={grad.start} />
            <stop offset=".75" stopColor={grad.end} />
          </linearGradient>
          <path
            fill="#ffffff"
            d="M112.86 11.95c5.65 0 9.86 4.21 9.86 9.86 0 5.59-4.21 9.81-9.86 9.81-5.59 0-9.81-4.22-9.81-9.81 0-5.64 4.21-9.86 9.81-9.86zm.02 14.61c2.7 0 4.55-2.11 4.55-4.75 0-2.7-1.85-4.78-4.55-4.78-2.67 0-4.55 2.08-4.55 4.78 0 2.65 1.89 4.75 4.55 4.75zM142.93 20.72l-5.2 6.24h-.9l-5.2-6.24v10.62h-5.39V12.23h4.52l6.52 7.56 6.52-7.56h4.52v19.11h-5.4V20.72zM152.96 12.23h9.83c3.85 0 7.11 2.28 7.11 7.16 0 4.44-3.26 7.05-7.11 7.05h-4.44v4.89h-5.39v-19.1zm5.4 4.67v4.89h3.57c1.38 0 2.42-.98 2.42-2.42 0-1.49-1.04-2.47-2.42-2.47h-3.57zM172.95 31.34V12.23h5.39v14.44h9.19v4.66h-14.58zM190.12 31.34V12.23h15.57v4.69h-10.4v2.53h8.35v4.41h-8.35v2.78h10.4v4.69h-15.57zM218.92 17.63v13.71h-5.39V17.63h-5.48v-5.39h16.3v5.39h-5.43zM227.09 31.34V12.23h15.57v4.69h-10.4v2.53h8.35v4.41h-8.35v2.78h10.4v4.69h-15.57zM246.69 31.34V12.23h5.39v14.44h9.19v4.66h-14.58zM266.09 24.15l-7.11-11.55v-.37h6.01l3.79 6.97 3.82-6.97h5.98v.37l-7.11 11.52v7.22h-5.39v-7.19zM96.82 24.4c-.77 1.34-2.15 2.22-3.9 2.22-2.67 0-4.55-2.11-4.55-4.75 0-2.7 1.88-4.78 4.55-4.78 1.73 0 3.11.86 3.88 2.18l4.42-2.85C99.51 13.72 96.49 12 92.9 12c-5.59 0-9.81 4.21-9.81 9.86 0 5.59 4.21 9.81 9.81 9.81 3.6 0 6.61-1.72 8.33-4.4l-4.41-2.87z"
          />
          <path
            fill={`#FFC3B5`}
            d="M100.01 49.26c-1.57 0-3.12-1.35-4.75-2.75 2.72-.7 4.66-2.78 4.66-5.64 0-4.27-3.45-6.35-7.1-6.35h-9.69v19.09h5.39v-6.85h.25c2.61 1.71 5.87 7.13 10.36 7.13 1.29 0 2.47-.34 3.26-.73l-.51-4.21c-.52.2-1.34.31-1.87.31zm-7.72-6.17h-3.76v-3.9h3.76c1.32 0 2.08.87 2.08 1.97 0 1.05-.76 1.93-2.08 1.93zm11.82 10.52h15.55v-4.69h-10.39v-2.78h8.34v-4.41h-8.34V39.2h10.39v-4.69h-15.55v19.1zm70.08-4.66V34.52h-5.39v19.09h14.57v-4.66h-9.18zm-36.11-14.43H121.8v5.39h5.47v13.7h5.39v-13.7h5.42v-5.39zm22.02 19.09h5.39V34.52h-5.39v19.09zm-15.61-19.09l-7.16 19.09h5.45l1.12-3.23h7.44l1.15 3.23h5.45l-7.08-19.09h-6.37zm.75 11.91l2.41-6.6 2.39 6.6h-4.8z"
          />
        </g>

        {/* Spacer */}
        <g>
          <path fill="#ffffff" d="M303.46 11.65h1v44.39h-1z" />
        </g>

        {/* Strap line */}
        <g>
          <path
            fill="#ffffff"
            d="M336.87 17.05v10.94h-1.98V17.05h-4.64v-1.98h11.02v1.98h-4.4zM353.78 22.35h-8v5.64h-1.98V15.07h1.98v5.55h8v-5.55h1.98v12.92h-1.98v-5.64zM359.78 27.99V15.07h10.01v1.75h-8.13v3.63h6.74v1.75h-6.74v4.05h8.13V28h-10.01zM379.6 22.52c0 2.32 1.18 3.84 3.7 3.84 2.56 0 3.76-1.63 3.76-3.86v-7.43h1.98v7.58c0 2.98-1.96 5.55-5.74 5.55-3.74 0-5.68-2.32-5.68-5.55v-7.58h1.98v7.45zM392.9 15.07h1.98v5.64h2.96l3.89-5.64h2.05v.3l-4.45 6.27c1.03 1.12 2.17 4.81 4.27 4.81.49 0 1.1-.13 1.56-.36l.23 1.6c-.53.27-1.37.49-2.17.49-3.19 0-4.43-4.56-5.6-5.74h-2.75v5.55h-1.98V15.07zM407.89 17.56c-.68-.13-1.03-.61-1.03-1.25 0-.89.47-1.39 1.33-1.39.87 0 1.37.57 1.37 1.39 0 1.27-.91 3.42-1.41 4.27l-1.14-.46.88-2.56zM418.89 20.34c-.84-.42-2.11-.78-3.19-.78-1.22 0-2.15.47-2.15 1.33 0 .7.48.89 1.42 1.12l2.05.47c1.67.42 2.47 1.22 2.47 2.64 0 1.82-1.44 3.06-3.95 3.06a8.74 8.74 0 0 1-3.78-.85l.4-1.71c.82.44 2.01.91 3.31.91 1.31 0 2.05-.47 2.05-1.27 0-.63-.63-.87-1.56-1.1l-1.92-.46c-1.61-.4-2.47-1.16-2.47-2.66 0-1.84 1.63-3.15 4.27-3.15 1.27 0 2.83.36 3.57.72l-.52 1.73zM430.23 20.15V28h-3.19V15.07h2.77l6.5 7.85v-7.85h3.19v12.92h-2.75l-6.52-7.84zM448.19 14.88c3.82 0 5.76 2.56 5.76 6.67 0 4.07-1.94 6.63-5.76 6.63-3.78 0-5.74-2.56-5.74-6.63 0-4.1 1.96-6.67 5.74-6.67zm0 10.38c2.07 0 2.66-1.67 2.66-3.7 0-2.07-.59-3.76-2.66-3.76-2.03 0-2.64 1.69-2.64 3.76 0 2.03.6 3.7 2.64 3.7zM458.05 24.61c1.2 0 1.9.68 1.9 1.84 0 1.16-.7 1.8-1.9 1.8s-1.88-.65-1.88-1.8c0-1.16.68-1.84 1.88-1.84zM465.36 15.07h2.34v12.92h-3.19V18.7l-3.55 1.94-1.2-2.41 5.6-3.16zM476.33 15.07h5.85c2.47 0 4.6 1.46 4.6 4.62 0 2.85-2.13 4.54-4.6 4.54h-3.88v3.76h-1.98V15.07zm1.97 1.73v5.7h3.57c1.58 0 2.85-1.06 2.85-2.81 0-1.92-1.27-2.89-2.85-2.89h-3.57zM489.64 27.99V15.07h1.98v11.19h7.05v1.73h-9.03zM504.81 15.07h2.28l5.13 12.92h-1.99l-1.14-2.85h-6.44l-1.18 2.85h-2.01l5.35-12.92zm-1.66 8.57h5.41l-2.62-6.59-2.79 6.59zM525.53 26.09c-1.16 1.1-3.15 2.09-5.3 2.09-3.82 0-6.61-2.47-6.61-6.63 0-4.2 2.79-6.67 6.61-6.67 3.31 0 5.21 1.86 5.28 4.88l-1.82.38c-.06-2.13-1.22-3.42-3.5-3.42-2.68 0-4.52 1.77-4.52 4.83 0 3.02 1.84 4.79 4.6 4.79 1.71 0 3.31-.82 4.29-1.73l.97 1.48zM528.65 27.99V15.07h10.01v1.75h-8.13v3.63h6.74v1.75h-6.74v4.05h8.13V28h-10.01zM551.75 17.05v10.94h-1.98V17.05h-4.64v-1.98h11.02v1.98h-4.4zM564.05 14.88c3.82 0 6.67 2.85 6.67 6.67 0 3.78-2.85 6.63-6.67 6.63-3.78 0-6.63-2.85-6.63-6.63 0-3.82 2.85-6.67 6.63-6.67zm.02 11.44c2.75 0 4.71-2.05 4.71-4.77 0-2.75-1.96-4.79-4.71-4.79-2.72 0-4.69 2.03-4.69 4.79-.01 2.72 1.97 4.77 4.69 4.77zM333.66 45.03v4.96h-1.88V37.07h9.63v1.75h-7.75v4.46h6.73v1.75h-6.73zM344.22 37.07h1.98v12.92h-1.98V37.07zM352.18 40.23v9.76h-1.98V37.07h1.73l8.21 9.8v-9.8h1.98v12.92h-1.73l-8.21-9.76zM366.15 37.07h5.24c3.82.02 6.67 2.28 6.67 6.48 0 4.16-2.85 6.44-6.67 6.44h-5.24V37.07zm1.97 1.73v9.46h3.19c2.75 0 4.71-1.67 4.71-4.71 0-3.08-1.96-4.73-4.71-4.75h-3.19zM388.07 44.43c-2.01-.55-2.98-1.71-2.98-3.5 0-2.24 1.77-4.03 5.28-4.03 1.84 0 3.67.49 4.67 1.03l-.91 2.83c-.99-.63-2.55-1.12-3.89-1.12-1.31 0-1.9.44-1.9 1.06 0 .57.38.8 1.18 1.03l2.28.68c2.37.7 3.46 1.79 3.46 3.57 0 2.49-2.09 4.2-5.32 4.2-1.92 0-3.8-.65-4.64-1.12l.74-2.89c.97.67 2.51 1.27 3.95 1.27 1.29 0 1.99-.53 1.99-1.23 0-.57-.57-.87-1.5-1.14l-2.41-.64zM407.36 44.84h-6.1v5.15h-3.19V37.07h3.19v5h6.1v-5h3.19v12.92h-3.19v-5.15zM419.97 36.88c3.82 0 6.67 2.85 6.67 6.67 0 3.78-2.85 6.63-6.67 6.63-3.78 0-6.63-2.85-6.63-6.63 0-3.82 2.85-6.67 6.63-6.67zm.02 10.3c2.09 0 3.51-1.58 3.51-3.63 0-2.09-1.42-3.65-3.51-3.65-2.03 0-3.51 1.56-3.51 3.65 0 2.05 1.48 3.63 3.51 3.63zM429.45 37.07h6.42c2.56 0 4.77 1.5 4.77 4.79 0 2.94-2.2 4.71-4.77 4.71h-3.23v3.42h-3.19V37.07zm3.19 2.78v3.95h2.72c1.12 0 1.98-.78 1.98-1.96 0-1.25-.85-1.99-1.98-1.99h-2.72zM445.39 44.43c-2.01-.55-2.98-1.71-2.98-3.5 0-2.24 1.77-4.03 5.28-4.03 1.84 0 3.67.49 4.67 1.03l-.91 2.83c-.99-.63-2.55-1.12-3.89-1.12-1.31 0-1.9.44-1.9 1.06 0 .57.38.8 1.18 1.03l2.28.68c2.37.7 3.46 1.79 3.46 3.57 0 2.49-2.09 4.2-5.32 4.2-1.92 0-3.8-.65-4.64-1.12l.74-2.89c.97.67 2.51 1.27 3.95 1.27 1.29 0 1.99-.53 1.99-1.23 0-.57-.57-.87-1.5-1.14l-2.41-.64zM466.14 40.27V50h-3.19v-9.73h-3.97v-3.19H470v3.19h-3.86zM478.05 36.88c3.82 0 6.67 2.85 6.67 6.67 0 3.78-2.85 6.63-6.67 6.63-3.78 0-6.63-2.85-6.63-6.63 0-3.82 2.85-6.67 6.63-6.67zm.02 10.3c2.09 0 3.51-1.58 3.51-3.63 0-2.09-1.42-3.65-3.51-3.65-2.03 0-3.51 1.56-3.51 3.65 0 2.05 1.48 3.63 3.51 3.63zM492.29 37.07h6.14c2.51 0 4.96 1.23 4.96 4.26 0 2.03-1.42 3.5-3.38 3.89 1.16 1.06 2.3 2.2 3.5 2.2.42 0 .97-.08 1.37-.25l.3 2.51c-.53.27-1.31.49-2.19.49-2.96 0-5.13-3.69-6.82-4.84h-.68v4.65h-3.19V37.07zm3.19 2.78v3.19h2.89c1.04 0 1.71-.65 1.71-1.6 0-.99-.67-1.6-1.71-1.6h-2.89zM507.16 49.99V37.07h10.37v2.77h-7.33v2.22h5.95v2.68h-5.95v2.47h7.33v2.77h-10.37zM523.64 42.15V50h-3.19V37.07h2.77l6.5 7.85v-7.85h3.19v12.92h-2.75l-6.52-7.84zM542.48 40.27V50h-3.19v-9.73h-3.97v-3.19h11.02v3.19h-3.86z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CRLogoSVG;
